import { useEffect, useState } from 'react';
import { Pressable } from 'react-native';
import { useOpenedState } from '../../hooks/useOpenedState';
import { ImageComponent as ImageComponentCropCircle } from '../crop-circle/Components/Image';
import { ImageLightBox } from '../modalImages/imageLightbox';
import { OutlinedImage } from './outlinedImage';
import { ProcessingPlaceholder } from './processingPlaceholder';
import {
  ImageData,
  MediaComponent,
  MediaComponentProps,
  SizePrefix,
} from './types';

export const ImageComponent: MediaComponent<ImageData> = ({
  hasLightbox = true,
  displayMode = 'card',
  displayWidth,
  onPress,
  canDelete,
  ...props
}: MediaComponentProps<ImageData>) => {
  const { isOpened, onOpen, onClose } = useOpenedState();
  const [showLightbox, setShowLightbox] = useState(false);
  const defaultSize = 88;
  const displaySize = displayWidth ?? defaultSize;

  useEffect(() => {
    setShowLightbox(hasLightbox && !props.mediaItem.isUploading);
  }, [hasLightbox, props.mediaItem.isUploading]);

  const handlePress = () => {
    if (onPress) {
      onPress();
      return;
    }
    onOpen();
  };

  return (
    <ProcessingPlaceholder
      processing={props.mediaItem.showProcessing ?? false}
      width={displaySize}
      height={displaySize}
      displayMode={displayMode}
      url={props.mediaItem.url}
      name={props.mediaItem.name ?? ''}
      extension={props.mediaItem.extension}
    >
      {displayMode === 'outlined' ? (
        <Pressable onPress={handlePress} style={{ width: displaySize }}>
          <OutlinedImage
            url={props.mediaItem.urlsBySize?.[SizePrefix.small]}
            size={displaySize}
          />
        </Pressable>
      ) : (
        <ImageComponentCropCircle
          size={displaySize}
          borderRadius={4}
          source={{
            uri: props.mediaItem.urlsBySize?.[SizePrefix.extraSmall],
          }}
          progress={props.mediaItem.uploadProgress}
          uploading={props.mediaItem.isUploading}
          onPress={handlePress}
          onClose={() => props.deleteMediaItem?.(props.mediaItem.id)}
          showClose={!!canDelete}
        />
      )}

      {showLightbox && (
        <ImageLightBox
          url={props.mediaItem.urlsBySize?.[SizePrefix.original]}
          isOpened={isOpened}
          onClose={onClose}
        />
      )}
    </ProcessingPlaceholder>
  );
};
